export default __webpack_public_path__ + "static/media/CNo.75-6.b8c08d0d.jpg";